import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../lib/api';
import { PageHeader, Loading, ErrorBox, Badge } from '../components/ui';

export function NotificationsPage() {
  const qc = useQueryClient();
  const log = useQuery({ queryKey: ['admin-notifications'], queryFn: () => adminApi.notifications() });
  const templates = useQuery({ queryKey: ['admin-templates'], queryFn: () => adminApi.templates() });
  const resend = useMutation({ mutationFn: (id: string) => adminApi.notificationResend(id), onSuccess: () => qc.invalidateQueries({ queryKey: ['admin-notifications'] }) });

  if (log.isLoading) return <Loading />;
  if (log.error) return <ErrorBox error={log.error} />;

  return (
    <div>
      <PageHeader title="Notifications" subtitle="Delivery log and message templates" />
      <div className="card mb-5">
        <table>
          <thead><tr><th>Recipient</th><th>Channel</th><th>Type</th><th>Order</th><th>Status</th><th>At</th><th /></tr></thead>
          <tbody>
            {((log.data as any)?.items ?? []).map((n: any) => (
              <tr key={n.id}>
                <td>{n.recipient ?? n.to}</td><td>{n.channel}</td><td>{n.type}</td><td>{n.orderId}</td>
                <td><Badge tone={n.status === 'failed' ? 'danger' : n.status === 'sent' ? 'success' : 'neutral'}>{n.status}</Badge></td>
                <td>{n.at}</td>
                <td>{n.status === 'failed' && <button className="btn-outline" onClick={() => resend.mutate(n.id)}>Resend</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!((log.data as any)?.items ?? []).length && <div className="text-sm py-10 text-center" style={{ color: 'var(--text-faint)' }}>No notifications sent yet</div>}
      </div>

      <div className="card p-4">
        <div className="font-semibold mb-3">Templates</div>
        <div className="space-y-1">
          {((templates.data as any)?.items ?? []).map((t: any) => (
            <div key={t.key} className="flex justify-between text-sm py-1.5 border-b" style={{ borderColor: 'var(--border)' }}>
              <span>{t.key}</span>
              <span style={{ color: 'var(--text-faint)' }}>{t.channels?.join(', ')}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
